import React from "react";
import { cn } from "@/lib/utils";

/* ---------------------------------------------------------------------------
   Boot screen — the one quiet state every surface passes through while a route
   chunk or the session loads. It is the same canvas the page will paint on, so
   nothing jumps: the only signal is a 2px brand line along the top edge, and it
   appears only if the wait exceeds ~250ms (see index.css `.boot-screen`).
   The pre-React state in public/index.html draws the identical line, so a cold
   load reads as one continuous moment instead of three different layouts.
--------------------------------------------------------------------------- */
export function BootScreen({ tone = "light", className, ...rest }) {
  return (
    <div
      className={cn("boot-screen min-h-screen", tone === "dark" ? "boot-screen--dark bg-ink" : "bg-canvas", className)}
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label="Loading"
      {...rest}
    />
  );
}
